type MetricGroupExpandParam =
  | 'experiments'
  | 'experimentCount'
  | 'guardedRollouts'
  | 'guardedRolloutCount'
  | 'releasePolicies'
  | 'releasePolicyCount';

export function getMetricGroupExpandParams(isReleasePoliciesEnabled: boolean): MetricGroupExpandParam[] {
  const expandParams: MetricGroupExpandParam[] = [
    'experiments',
    'experimentCount',
    'guardedRollouts',
    'guardedRolloutCount',
  ];

  if (isReleasePoliciesEnabled) {
    expandParams.push('releasePolicies', 'releasePolicyCount');
  }

  return expandParams;
}
